import styled from '@emotion/styled'

const SELECTED = 'selected'
const SELECTABLE = 'selectable'
const DISABLED = 'disbaled'

const getSelector = ({ isSelected, isSelectable }) => {
  if (isSelected) return SELECTED
  if (isSelectable) return SELECTABLE
  return DISABLED
}

export const PhaseCircle = styled.g((props) => {
  const { isSelectable, theme } = props

  const {
    buttonPrimaryColor,
    btnDisabledColor,
    btnDisabledBg,
    btnPrimaryFocusColor,
  } = theme

  const { fill, stroke, cursor } = {
    [SELECTED]: {
      fill: btnPrimaryFocusColor,
      stroke: buttonPrimaryColor,
      cursor: 'inherit',
    },
    [SELECTABLE]: {
      fill: buttonPrimaryColor,
      stroke: buttonPrimaryColor,
      cursor: 'pointer',
    },
    [DISABLED]: {
      fill: btnDisabledBg,
      stroke: btnDisabledColor,
      cursor: 'not-allowed',
    },
  }[getSelector(props)]

  // Bug 479123 Issue 11: Only apply hover effects when isSelectable is true
  return `
    overflow: visible !important;
    fill:${fill};
    stroke:${stroke};
    &:hover {
      cursor:${cursor};
      ${
        isSelectable
          ? `
        circle:last-of-type {
          stroke: ${btnPrimaryFocusColor};
        }
        path {
          fill: ${btnPrimaryFocusColor};
        }
      `
          : ''
      }
    }
  `
})

export const PhaseCircleBackground = styled.circle((props) => {
  const {
    theme: { buttonPrimaryColor },
  } = props

  return `
    fill: ${buttonPrimaryColor}
  `
})

export const PhaseCircleOutline = styled.circle((props) => {
  const {
    theme: { btnPrimaryFocusColor, btnDisabledColor, btnPrimaryHoverBg },
  } = props

  const stroke = {
    [SELECTED]: btnPrimaryFocusColor,
    [SELECTABLE]: btnPrimaryHoverBg,
    [DISABLED]: btnDisabledColor,
  }[getSelector(props)]

  return `
    stroke:${stroke};
  `
})

export const PhaseCirclePath = styled.path((props) => {
  const {
    theme: { buttonPrimaryColor, btnPrimaryHoverBg, btnDisabledColor },
  } = props

  const fill = {
    [SELECTED]: buttonPrimaryColor,
    [SELECTABLE]: btnPrimaryHoverBg,
    [DISABLED]: btnDisabledColor,
  }[getSelector(props)]

  return `
    fill:${fill};
  `
})

export const PhaseLabel = styled.text((props) => {
  const {
    theme: { btnPrimaryFocusColor, btnDisabledColor },
  } = props

  const { fill, cursor } = {
    [SELECTED]: { fill: btnPrimaryFocusColor, cursor: 'inherit' },
    [SELECTABLE]: { fill: btnPrimaryFocusColor, cursor: 'pointer' },
    [DISABLED]: { fill: btnDisabledColor, cursor: 'not-allowed' },
  }[getSelector(props)]

  return ` 
    cursor: ${cursor};
    fill: ${fill};
  `
})
